import Button         from "@mui/material/Button";
import useStyles      from "_styles/atoms/bottomStickyButton";
import { MobileIcon } from "_root/assets";

const BottomStickyButton = ( { title, customStyle, handleDownloadClick } ) => {
	const classes = useStyles ();

	return (
		<div
			className = { classes.bottomStickyBtnContainer }
			style = { customStyle }
		>
			<Button
				className = { classes.downloadBtn }
				onClick = { () => handleDownloadClick () }
			>
				<MobileIcon className = { classes.mobileSvg } />

				{title}
			</Button>
		</div>
	);
};

export default BottomStickyButton;
